/*
 * PDP redesign — bevestiging na toevoegen aan het mandje.
 *
 * Het thema legt producten via AJAX in het mandje en meldt dat met de
 * gebeurtenis 'cart:item-added'. Daar haken we op aan: de knoptekst wisselt
 * kort naar een bevestiging en keert daarna terug.
 *
 * De tekst staat in data-content, dezelfde manier waarop het thema zijn
 * knoplabels zet; anders zou de opmaak van de knop niet kloppen.
 */
(function () {
  'use strict';

  var DUUR = 1800;
  var BEVESTIGING = 'ADDED TO CART ✓';
  var lopend = null;

  function knopTeksten() {
    return document.querySelectorAll(
      '.pdp-v2 .single-add-to-cart-button .single-add-to-cart-button--text'
    );
  }

  document.addEventListener('cart:item-added', function () {
    if (!window.matchMedia('(max-width: 1067px)').matches) return;

    var velden = knopTeksten();
    if (!velden.length) return;

    // Bij snel achter elkaar toevoegen: eerst de vorige afronden, anders
    // blijft de bevestiging hangen of keert de knop te vroeg terug.
    if (lopend) {
      clearTimeout(lopend.timer);
      lopend.velden.forEach(function (v, i) {
        v.setAttribute('data-content', lopend.origineel[i]);
      });
    }

    var origineel = [];
    velden.forEach(function (v) {
      origineel.push(v.getAttribute('data-content') || '');
      v.setAttribute('data-content', BEVESTIGING);
    });

    lopend = {
      velden: velden,
      origineel: origineel,
      timer: setTimeout(function () {
        velden.forEach(function (v, i) {
          v.setAttribute('data-content', origineel[i]);
        });
        lopend = null;
      }, DUUR),
    };
  });
})();

/* ---------------------------------------------------------------
   Vangnet: nooit een maat voorgeselecteerd die niet leverbaar is

   Shopify zet bij het laden zelf de eerste beschikbare variant klaar.
   De fit finder overschrijft die daarna met zijn aanbeveling, en die
   houdt geen rekening met voorraad — zo kom je op 32/34 uit terwijl
   alleen 32/32 er ligt.

   Dit script corrigeert dat en houdt daarbij zoveel mogelijk van de
   aanbeveling overeind: het laat opties van achter naar voren los tot
   er een variant is die wel op voorraad ligt. 32/34 wordt dus 32/32,
   niet terug naar 24/32.

   Zodra de klant zelf iets aanraakt, bemoeit dit script zich nergens
   meer mee.
   --------------------------------------------------------------- */
(function () {
  var picker = document.querySelector('.pdp-v2 variant-selects');
  if (!picker) return;

  var bron = picker.querySelector('script[type="application/json"]');
  if (!bron) return;

  var varianten;
  try {
    varianten = JSON.parse(bron.textContent);
  } catch (e) {
    return;
  }
  if (!Array.isArray(varianten) || !varianten.length) return;

  var actief = true;
  function stop() { actief = false; }
  picker.addEventListener('pointerdown', stop, true);
  picker.addEventListener('keydown', stop, true);
  window.setTimeout(stop, 8000);

  // De volgorde in de DOM hoeft niet de optievolgorde te zijn; data-index
  // vertelt bij welke optiepositie een veld hoort.
  function velden() {
    var lijst = Array.prototype.slice.call(
      picker.querySelectorAll('fieldset.product-form__input[data-index]')
    );
    return lijst
      .map(function (el) {
        var ruw = String(el.getAttribute('data-index')).replace('option', '');
        return { positie: parseInt(ruw, 10) - 1, el: el };
      })
      .filter(function (v) { return v.positie >= 0; })
      .sort(function (a, b) { return a.positie - b.positie; });
  }

  function keuzeVan(vs) {
    var uit = [];
    vs.forEach(function (v) {
      var aan = v.el.querySelector('input[type="radio"]:checked') || v.el.querySelector('select');
      uit[v.positie] = aan ? aan.value : null;
    });
    return uit;
  }

  function past(variant, keuze, tot) {
    for (var i = 0; i < tot; i++) {
      if (keuze[i] != null && variant.options[i] !== keuze[i]) return false;
    }
    return true;
  }

  function eersteBeschikbare(keuze, tot) {
    for (var i = 0; i < varianten.length; i++) {
      if (varianten[i].available && past(varianten[i], keuze, tot)) return varianten[i];
    }
    return null;
  }

  function corrigeer() {
    if (!actief) return;

    var vs = velden();
    if (!vs.length) return;

    var keuze = keuzeVan(vs);
    if (eersteBeschikbare(keuze, keuze.length)) return; // huidige keuze ligt er

    var doel = null;
    for (var k = keuze.length - 1; k >= 0 && !doel; k--) {
      doel = eersteBeschikbare(keuze, k);
    }
    if (!doel) return; // hele product uitverkocht: niets aan te doen

    var laatste = null;
    vs.forEach(function (v) {
      var wens = doel.options[v.positie];
      if (wens === undefined) return;

      var knoppen = v.el.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < knoppen.length; i++) {
        if (knoppen[i].value === wens && !knoppen[i].checked) {
          knoppen[i].checked = true;
          laatste = knoppen[i];
        }
      }

      var lijst = v.el.querySelector('select');
      if (lijst && lijst.value !== wens) {
        lijst.value = wens;
        laatste = lijst;
      }
    });

    // Eén change-event volstaat: het thema leest daarna alle velden uit.
    if (laatste) {
      laatste.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  var gepland = false;
  function plan() {
    if (gepland || !actief) return;
    gepland = true;
    window.setTimeout(function () {
      gepland = false;
      corrigeer();
    }, 60);
  }

  picker.addEventListener('change', plan);
  new MutationObserver(plan).observe(picker, {
    subtree: true,
    attributes: true,
    attributeFilter: ['checked', 'class']
  });
  plan();
})();

/* ---------------------------------------------------------------
   Sticky koopbalk

   Het thema laat zijn eigen knop verschijnen zodra de gewone
   koopknop uit beeld scrollt. Die knop hergebruiken we; hij krijgt
   alleen het label uit het design ("ADD TO CART · prijs") en voegt
   direct toe in plaats van eerst een venster te openen, zolang er
   een leverbare maat gekozen is. Is dat niet zo, dan valt hij terug
   op het maatvenster van het thema.

   Ernaast staat "Find your size", die de fit quiz opent. Die knop
   blijft verborgen op producten waar de fit quiz niets toont.
   --------------------------------------------------------------- */
(function () {
  var balk = document.querySelector('.pdp-sticky-bar');
  if (!balk) return;

  var koopknop = balk.querySelector('.product-add-to-cart-sticky');
  var fitknop = balk.querySelector('.pdp-sticky-fit');

  /* --- zichtbaarheid van de balk --------------------------------- */
  if (koopknop) {
    var spiegel = function () {
      balk.classList.toggle(
        'pdp-sticky-bar--zichtbaar',
        koopknop.classList.contains('sticky--visible')
      );
    };
    new MutationObserver(spiegel).observe(koopknop, {
      attributes: true,
      attributeFilter: ['class']
    });
    spiegel();
  }

  /* --- label met prijs ------------------------------------------- */
  function echteKoopknop() {
    return document.getElementById('AddToCart');
  }

  function prijsTekst() {
    var blok = document.querySelector('.pdp-v2 [id^="price-"]:not([id$="--sticky"])');
    if (!blok) return '';
    var bedrag = blok.querySelector('.amount');
    return bedrag ? (bedrag.textContent || '').trim() : '';
  }

  function werkLabelBij() {
    if (!koopknop) return;
    var span = koopknop.querySelector('[data-content]');
    if (!span) return;

    var echt = echteKoopknop();
    if (echt && echt.disabled) {
      var tekst = echt.querySelector('[data-content]');
      span.dataset.content = tekst ? tekst.dataset.content : 'Sold out';
      return;
    }

    var prijs = prijsTekst();
    span.dataset.content = prijs ? 'ADD TO CART · ' + prijs : 'ADD TO CART';
  }

  var prijsblok = document.querySelector('.pdp-v2 [id^="price-"]:not([id$="--sticky"])');
  if (prijsblok) {
    new MutationObserver(werkLabelBij).observe(prijsblok, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }
  document.addEventListener('product:variant-change', werkLabelBij);
  werkLabelBij();
})();

/* ---------------------------------------------------------------
   Fit quiz openen vanaf twee plekken

   De quiz (EasySize) rendert zijn eigen widget in de maatkiezer.
   Wij bouwen die niet na; we laten onze knoppen de widget aanklikken,
   zodat er precies één quiz-flow bestaat.

   Twee aanleidingen: de rij onderaan de Fit & sizing-kaart en de knop
   in de sticky balk. Beide blijven verborgen zolang de quiz op dit
   product niets toont, want niet elk artikel wordt ondersteund.
   --------------------------------------------------------------- */
(function () {
  var knoppen = Array.prototype.slice.call(
    document.querySelectorAll('.pdp-fit-card__quiz, .pdp-sticky-fit')
  );
  if (!knoppen.length) return;

  var TRIGGER = /find your size|we recommend|your size|fit quiz|size advice/i;

  function heeftInhoud(el) {
    if (!el || !el.getClientRects().length) return false;
    // innerText telt scriptinhoud niet mee, textContent wel.
    var tekst = (el.innerText || '').trim();
    return tekst.length > 0 || !!el.querySelector('svg, img');
  }

  // EasySize is ingesteld om in <variant-selects> te renderen, niet in de
  // lege container van het app-blok. Omdat dat per versie kan verschillen,
  // kijken we op meerdere plekken.
  function vindWidget() {
    var kandidaten = [];

    Array.prototype.push.apply(
      kandidaten,
      document.querySelectorAll('[class*="easysize"], [id*="easysize"], [class*="EasySize"]')
    );

    var picker = document.querySelector('.pdp-v2 variant-selects');
    if (picker) {
      Array.prototype.forEach.call(picker.children, function (kind) {
        if (kind.tagName.toLowerCase() === 'script') return;
        if (kind.classList.contains('variations')) return;
        kandidaten.push(kind);
      });
    }

    var blok = document.querySelector('.fit-quiz-wrapper');
    if (blok) kandidaten.push(blok);

    for (var i = 0; i < kandidaten.length; i++) {
      // Onze eigen knoppen niet als widget aanzien.
      if (kandidaten[i].closest('.pdp-fit-card, .pdp-sticky-bar')) continue;
      if (heeftInhoud(kandidaten[i])) return kandidaten[i];
    }
    return null;
  }

  function klikbaarIn(houder) {
    var alle = Array.prototype.slice.call(houder.querySelectorAll('*'));
    var isKnop = function (el) {
      var tag = el.tagName.toLowerCase();
      return tag === 'a' || tag === 'button' || el.getAttribute('role') === 'button';
    };
    var past = function (el) {
      var tekst = (el.innerText || '').trim();
      return tekst && tekst.length < 80 && TRIGGER.test(tekst);
    };

    // Eerst een echte link of knop met de juiste tekst: dat is het element
    // dat de klant zelf zou aantikken.
    for (var i = 0; i < alle.length; i++) {
      if (isKnop(alle[i]) && past(alle[i])) return alle[i];
    }
    for (var j = alle.length - 1; j >= 0; j--) {
      if (past(alle[j])) return alle[j];
    }
    for (var k = 0; k < alle.length; k++) {
      if (isKnop(alle[k])) return alle[k];
    }
    for (var m = 0; m < alle.length; m++) {
      if (!alle[m].children.length && (alle[m].innerText || '').trim()) return alle[m];
    }
    return houder;
  }

  // Sommige widgets luisteren op pointerdown of mousedown in plaats van
  // op click; we spelen daarom de hele reeks af.
  function simuleerKlik(el) {
    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (soort) {
      var Constructor = soort.indexOf('pointer') === 0 && window.PointerEvent
        ? window.PointerEvent
        : window.MouseEvent;
      el.dispatchEvent(new Constructor(soort, { bubbles: true, cancelable: true, view: window }));
    });
  }

  // De oproep van de app staat al in de Fit & sizing-kaart en in de sticky
  // balk, dus die van de app zelf mag uit beeld. Waar EasySize hem neerzet
  // verschilt per versie — soms in de maatkiezer, soms als los blok
  // ernaast. Daarom zoeken we op de tekst in plaats van op een plek: het
  // buitenste element in de koopkolom dat alleen die oproep bevat.
  // Het buitenste kleine element in de koopkolom dat alleen de oproep van
  // de app bevat. Onze eigen knoppen tellen niet mee.
  function vindEigenOproep() {
    var houder = document.querySelector('.pdp-v2 .product-information--inner');
    if (!houder) return null;

    var alle = houder.querySelectorAll('*');
    for (var i = 0; i < alle.length; i++) {
      var el = alle[i];

      if (el.closest('.pdp-fit-card-wrap') || el.closest('.pdp-sticky-bar')) continue;
      if (!el.getClientRects().length) continue;

      var tekst = (el.innerText || '').trim();
      // Een blok met meer inhoud is de maatkiezer of de hele kolom; we
      // zoeken juist het kleine element met alleen de oproep erin.
      if (!tekst || tekst.length > 60) continue;
      if (!TRIGGER.test(tekst)) continue;

      return el;
    }
    return null;
  }

  function toonAlsAanwezig() {
    // De oproep van de app zelf is zowel wat we verbergen als wat we
    // aanklikken. Lukt het zoeken op tekst niet, dan valt hij terug op
    // het zoeken naar de widget zelf.
    var oproep = vindEigenOproep();
    var widget = oproep || vindWidget();
    if (!widget) return false;

    widget.classList.add('pdp-quiz-bron');
    knoppen.forEach(function (knop) { knop.hidden = false; });

    // Pas klaar als we de regel op tekst hebben gevonden. De app rendert
    // die soms later dan de rest; stoppen we al bij het eerste het beste
    // element, dan blijft die regel daarna zichtbaar staan.
    return !!oproep;
  }

  knoppen.forEach(function (knop) {
    knop.addEventListener('click', function () {
      // Dezelfde volgorde als bij het tonen: eerst de oproep die we op
      // tekst herkennen, anders de widget zelf.
      var widget = vindEigenOproep() || vindWidget();
      if (!widget) return;
      simuleerKlik(klikbaarIn(widget));
    });
  });

  if (!toonAlsAanwezig()) {
    var kijker = new MutationObserver(function () {
      if (toonAlsAanwezig()) kijker.disconnect();
    });
    kijker.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { kijker.disconnect(); }, 20000);
  }
})();

/* ---------------------------------------------------------------
   Size guide in de kop van de Fit & sizing-kaart

   Het thema zet zijn maattabel-knop naast het maatlabel en opent
   daarmee een eigen venster. Het desktopontwerp wil die link in de
   kop van de kaart. In plaats van het venster na te bouwen laten we
   onze knop de bestaande knop aanklikken; zo blijft er één maattabel.

   Staat er geen maattabel ingesteld, dan blijft onze knop verborgen.
   --------------------------------------------------------------- */
(function () {
  var knop = document.querySelector('.pdp-fit-card__guide');
  if (!knop) return;

  var opener = document.querySelector('.pdp-v2 .variations .product-popup-modal__opener');
  var origineel = opener && opener.querySelector('button');
  if (!origineel) return;

  var label = (origineel.textContent || '').trim();
  knop.textContent = label || 'Size guide';
  knop.hidden = false;

  knop.addEventListener('click', function () {
    origineel.click();
  });
})();

/* ---------------------------------------------------------------
   Accordions op desktop dichtklappen

   Het sjabloon zet "Product details" standaard open, wat op mobiel
   prettig is. Op desktop vraagt het ontwerp dat alle vier gesloten
   beginnen: zo blijft de koopkolom kort genoeg om in beeld te passen
   en staan de shopping benefits meteen zichtbaar.
   --------------------------------------------------------------- */
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(min-width: 1068px)');
  if (!mq.matches) return;

  var rijen = document.querySelectorAll('.pdp-v2 .product__accordion details');
  Array.prototype.forEach.call(rijen, function (d) { d.open = false; });
})();

/* ---------------------------------------------------------------
   Shopping benefits laten rouleren op mobiel

   Eén regel tegelijk, die van links binnenschuift en na een paar
   seconden plaatsmaakt voor de volgende. Geldt op telefoon én
   computer, zodat het blok zich overal hetzelfde gedraagt.

   Wie in zijn systeeminstellingen beweging heeft beperkt, krijgt
   gewoon het stilstaande lijstje.
   --------------------------------------------------------------- */
(function () {
  if (!window.matchMedia) return;

  var blok = document.querySelector('.pdp-v2 .pdp-benefits');
  if (!blok) return;

  var rijen = Array.prototype.slice.call(blok.querySelectorAll('.pdp-benefits__row'));
  if (rijen.length < 2) return;

  var WISSEL = 2200;
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var timer = null;
  var huidig = 0;

  function toon(n) {
    rijen.forEach(function (rij, i) {
      rij.classList.toggle('is-actief', i === n);
    });
  }

  function aan() {
    if (timer) return;
    blok.classList.add('pdp-benefits--rouleert');
    huidig = 0;
    toon(huidig);
    timer = window.setInterval(function () {
      huidig = (huidig + 1) % rijen.length;
      toon(huidig);
    }, WISSEL);
  }

  function uit() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
    blok.classList.remove('pdp-benefits--rouleert');
    rijen.forEach(function (rij) { rij.classList.remove('is-actief'); });
  }

  function volg() {
    if (!rustig.matches) aan();
    else uit();
  }

  // Doorlopen terwijl het tabblad op de achtergrond staat heeft geen zin.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) uit();
    else volg();
  });

  volg();
  if (rustig.addEventListener) rustig.addEventListener('change', volg);
  else if (rustig.addListener) rustig.addListener(volg);
})();

/* ---------------------------------------------------------------
   "Learn more" bij de spaarpunten naar de eigen clubpagina

   De loyaliteitsapp zet daar zijn eigen adres neer
   (account.loisjeanstore.com/pages/<id>). Dat leidt de klant weg van
   de winkel naar een pagina van de app.

   Hier wijzen we hem naar de clubpagina in de winkel zelf. De app
   rendert zijn blok asynchroon en kan het opnieuw opbouwen, dus we
   blijven even meekijken en zetten het adres telkens terug.

   Let op: dit is een correctie vanuit het thema. Staat de app het toe,
   dan hoort dit adres in de instellingen van Leat zelf.
   --------------------------------------------------------------- */
(function () {
  var DOEL = 'https://loisjeanstore.com/pages/club62';

  function zet() {
    var blok = document.querySelector('.pdp-v2 .product-app-block > [id*="leat_loyalty"]');
    if (!blok) return false;

    var links = blok.querySelectorAll('a[href]');
    if (!links.length) return false;

    Array.prototype.forEach.call(links, function (a) {
      if (a.getAttribute('href') !== DOEL) a.setAttribute('href', DOEL);
    });
    return true;
  }

  zet();

  if (!window.MutationObserver) return;

  // Niet loskoppelen zodra het één keer lukt: de app bouwt zijn blok
  // opnieuw op bij een variantwissel en zet dan zijn eigen adres terug.
  var kijker = new MutationObserver(zet);
  kijker.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(function () { kijker.disconnect(); }, 20000);
})();

/* ---------------------------------------------------------------
   Kleurbolletje blijft zichtbaar bij een onbekende kleurnaam

   Het thema zet de kleur als --option-color op het bolletje en heeft
   een terugval voor het geval die variabele ontbreekt. Maar bij een
   kleurnaam die niet in de kleurenlijst staat, zet het de náám zelf
   als waarde — bijvoorbeeld "l32 - 822 dark ivy". Dat is geen geldige
   kleur, dus de terugval slaat niet aan en het bolletje wordt volledig
   doorzichtig. Op de Culotte waren vier van de zeven zo onzichtbaar.

   In plaats van er in de opmaak een eigen laag overheen te leggen —
   dat botste met de ronding en met de uitverkocht-staat — vullen we
   hier gewoon een neutrale waarde in. Het thema schildert daarna zoals
   het altijd doet, met dezelfde vorm en dezelfde toestanden.

   Dit lost de weergave op, niet de oorzaak: die varianten hebben een
   artikelcode in hun kleurnaam en horen in de kleurenlijst van het
   thema, of moeten hernoemd worden.
   --------------------------------------------------------------- */
(function () {
  var NEUTRAAL = '#ededed';

  function herstel() {
    var labels = document.querySelectorAll(
      '.pdp-v2 .variations .product-form__input--color label'
    );
    Array.prototype.forEach.call(labels, function (label) {
      var waarde = (label.style.getPropertyValue('--option-color') || '').trim();
      if (!waarde) return;

      var geldig = window.CSS && window.CSS.supports
        ? window.CSS.supports('color', waarde)
        : /^(#|rgb|hsl|var\()/i.test(waarde);

      if (!geldig) label.style.setProperty('--option-color', NEUTRAAL);
    });
  }

  herstel();

  // De kiezer wordt opnieuw opgebouwd bij een variantwissel.
  if (!window.MutationObserver) return;
  var picker = document.querySelector('.pdp-v2 variant-selects');
  if (picker) new MutationObserver(herstel).observe(picker, { childList: true, subtree: true });
})();

/*
 * Inzoomen op de productfoto's.
 *
 * Over elke foto ligt een onzichtbare link naar het beeldbestand. Het thema
 * vangt die klik normaal af en opent er een zoomvenster mee, maar die code
 * zit in de carrousel-component (`product-slider`) en die gebruiken wij niet
 * — onze galerij staat verticaal. Zonder afvanger volgde de browser dus
 * gewoon de link: het jpg-bestand in een nieuw tabblad, en de bezoeker weg
 * van de winkel.
 *
 * Hieronder doen we wat het thema in de carrousel doet: de klik afvangen en
 * PhotoSwipe openen. Die staat al klaar in de pagina, inclusief zijn eigen
 * venster.
 */
(function () {
  'use strict';

  var GALERIJ = '.product-grid--vertical';
  var ZOOM = '.product-single__media-zoom';

  function zichtbareFotos() {
    var houder = document.querySelector(GALERIJ);
    if (!houder) return [];
    return Array.prototype.filter.call(
      houder.querySelectorAll('.product-single__media-image'),
      function (media) {
        // Bij een variantwissel verbergt het thema de foto's van de andere
        // kleur; die horen niet in het zoomvenster te staan.
        return media.offsetParent !== null && media.querySelector(ZOOM);
      }
    );
  }

  function bouwLijst(fotos) {
    return fotos.map(function (media) {
      var link = media.querySelector(ZOOM);
      return {
        src: link.getAttribute('href'),
        msrc: link.getAttribute('data-msrc') || undefined,
        w: parseInt(link.getAttribute('data-w'), 10) || 1200,
        h: parseInt(link.getAttribute('data-h'), 10) || 1600
      };
    });
  }

  function open(index) {
    var venster = document.querySelector('.pswp');
    if (!venster || typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') {
      return false;
    }
    var fotos = zichtbareFotos();
    var lijst = bouwLijst(fotos);
    if (!lijst.length) return false;

    var kijker = new PhotoSwipe(venster, PhotoSwipeUI_Default, lijst, {
      index: Math.max(0, Math.min(index, lijst.length - 1)),
      maxSpreadZoom: 2,
      loop: false,
      allowPanToNext: false,
      closeOnScroll: false,
      showHideOpacity: false,
      arrowKeys: true,
      history: false,
      captionEl: false,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false,
      counterEl: true,
      arrowEl: true,
      preloaderEl: true,
      // Laat het venster openvouwen vanaf de foto waarop geklikt is.
      getThumbBoundsFn: function (i) {
        var media = zichtbareFotos()[i];
        if (!media) return null;
        var vak = media.getBoundingClientRect();
        var omhoog = window.pageYOffset || document.documentElement.scrollTop;
        return { x: vak.left, y: vak.top + omhoog, w: vak.width };
      }
    });
    kijker.init();
    return true;
  }

  // Eén afvanger op de galerij, zodat hij blijft werken als het thema de
  // foto's vervangt na een variantwissel.
  document.addEventListener('click', function (gebeurtenis) {
    var link = gebeurtenis.target.closest ? gebeurtenis.target.closest(ZOOM) : null;
    if (!link) return;
    if (!link.closest(GALERIJ)) return;

    // Hoe dan ook niet het bestand in een nieuw tabblad openen — ook niet
    // als PhotoSwipe om wat voor reden dan ook niet beschikbaar is.
    gebeurtenis.preventDefault();

    var media = link.closest('.product-single__media-image');
    var index = zichtbareFotos().indexOf(media);
    open(index < 0 ? 0 : index);
  }, false);
})();
